import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

export default function NotFound() {
  return (
    <div className="flex min-h-[70vh] items-center justify-center px-5 pt-24" data-testid="not-found-page">
      <div className="max-w-xl text-center">
        <p className="text-sm font-semibold uppercase tracking-[0.3em] text-primary">Erreur 404</p>
        <h1 className="mt-4 text-4xl font-semibold tracking-tight sm:text-5xl">Cette page n’existe pas.</h1>
        <p className="mt-5 text-muted-foreground">Revenez à l’accueil pour poursuivre votre visite.</p>
        <Button asChild className="mt-8 rounded-full px-8" data-testid="not-found-home-button">
          <Link to="/">Retour à l’accueil</Link>
        </Button>
      </div>
    </div>
  );
}
